import {assert} from 'Asserts';
import {isAnalyticsDashboardViewStateId} from 'insights/analytics-dashboards/details/view-state/AnalyticsDashboardViewState';
import APIUtil from 'util/APIUtil';

function parseAnalyticsQueryViewStateId(analyticsQueryViewStateId: string): {
  analyticsDashboardViewStateId: string;
  analyticsQueryViewStateText: string;
  analyticsQueryId: string;
} | null {
  const idParts = analyticsQueryViewStateId.split('--');
  return idParts.length === 3
    ? {
        analyticsDashboardViewStateId: idParts[0],
        analyticsQueryViewStateText: idParts[1],
        analyticsQueryId: idParts[2],
      }
    : null;
}

/**
 * Filter list of analyticsQueryViewStateId to the ones that match the given analyticsQueryId.
 */
export function filterAnalyticsQueryViewStateIds(
  analyticsQueryViewStateIds: Array<string>,
  analyticsQueryIdFilter: string
): Array<string> {
  assert(APIUtil.isAnalyticsQuery(analyticsQueryIdFilter), 'Expected a valid analyticsQuery id');

  return analyticsQueryViewStateIds.filter(
    (analyticsQueryViewStateId) =>
      getAnalyticsQueryFromViewStateId(analyticsQueryViewStateId) === analyticsQueryIdFilter
  );
}

export function getAnalyticsQueryFromViewStateId(analyticsQueryViewStateId: string): string {
  assert(
    isAnalyticsQueryViewStateId(analyticsQueryViewStateId),
    'Expected to receive a valid AnalyticsQueryViewState Id',
    {analyticsQueryViewStateId}
  );

  const splitViewStateId = parseAnalyticsQueryViewStateId(analyticsQueryViewStateId);
  return splitViewStateId!.analyticsQueryId;
}

export function getAnalyticsQueryViewStateId(
  analyticsQueryId: string,
  analyticsDashboardViewStateId: string
): string {
  return `${analyticsDashboardViewStateId}--AnalyticsQueryViewState--${analyticsQueryId}`;
}

export function isAnalyticsQueryViewStateId(maybeAnalyticsQueryViewId: string): boolean {
  const splitViewStateId = parseAnalyticsQueryViewStateId(maybeAnalyticsQueryViewId);
  return (
    splitViewStateId != null &&
    isAnalyticsDashboardViewStateId(splitViewStateId.analyticsDashboardViewStateId) &&
    splitViewStateId.analyticsQueryViewStateText === 'AnalyticsQueryViewState' &&
    APIUtil.isAnalyticsQuery(splitViewStateId.analyticsQueryId)
  );
}
